export default __webpack_public_path__ + "static/2-6b150c497b71b81e8fd8d9a1d3e59cdc.jpg";